<div class="form-group">
  <input [type]="type" 
         class="form-control form-input input-form-full-space" 
         [class.field-error-highlight]="hasError"
         [formControl]="formGroup.get(controlName)"
         [id]="id" 
         (input)="onInputChange($event)"
         (blur)="onInputBlur($event)"
         [class.isEmpty]="formGroup.get(controlName)?.value === '' || formGroup.get(controlName)?.value === null" />
  <label [for]="id" class="form-input-label">{{ label }}</label>
  <div class="text-danger" *ngIf="submitted && formGroup.get(controlName)?.errors?.required">
    <label class="feld-error label-form-style d-flex pl-2" style="color: #E40052; font-weight: 500;">
      <img src="/assets/external/warnning-vector.svg" class="img-fluid pr-1" />
      {{ errorMessage }}
    </label>
  </div>
  <div class="text-danger"
    *ngIf="submitted && (formGroup.get(controlName).errors?.min || formGroup.get(controlName).errors?.max)">
    <label class="feld-error label-form-style d-flex pl-2" style="color: #E40052; font-weight: 500;">
      <img [attr.src]="'/assets/external/warnning-vector.svg'" class="img-fluid pr-1" />
      {{minMaxErrorMessage}}
    </label>
  </div>
  <div class="text-danger"
    *ngIf="submitted && (formGroup.get(controlName).errors?.minlength || formGroup.get(controlName).errors?.maxlength)">
    <label class="feld-error label-form-style d-flex pl-2" style="color: #E40052; font-weight: 500;">
      <img [attr.src]="'/assets/external/warnning-vector.svg'" class="img-fluid pr-1" />
      {{minMaxErrorMessage}}
    </label>
  </div>
  <div class="text-danger"
    *ngIf="submitted && (formGroup.get(controlName).errors?.pattern)">
    <label class="feld-error label-form-style d-flex pl-2" style="color: #E40052; font-weight: 500;">
      <img [attr.src]="'/assets/external/warnning-vector.svg'" class="img-fluid pr-1" />
      Solo se permiten números
    </label>
  </div>
  <div class="text-danger"
    *ngIf="submitted && (formGroup.get(controlName).errors?.invalidEmail)">
    <label class="feld-error label-form-style d-flex pl-2" style="color: #E40052; font-weight: 500;">
      <img [attr.src]="'/assets/external/warnning-vector.svg'" class="img-fluid pr-1" />
      Esta dirección de correo electrónico no es válida
    </label>
  </div>
</div>

<!-- <app-input-field
    [form]="stepTwoForm"
    controlName="agentCode"
    label="Código"
    [inputType]="'text'"
   
  ></app-input-field> -->